exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* DO NOT EDIT\n@todo This file is copied from GUI and should be pulled out into a shared library.\nSee https://github.com/LLK/scratch-paint/issues/13 */\n\n.button_button_u6SE2 {\n    background: none;\n    cursor: pointer;\n    -webkit-user-select: none;\n       -moz-user-select: none;\n        -ms-user-select: none;\n            user-select: none;\n}\n\n.button_button_u6SE2:active {\n    background-color: hsla(215, 100%, 65%, 0.20); \n}\n\n.button_highlighted_2cM8r.button_button_u6SE2 {\n    background-color: hsla(215, 100%, 65%, 0.20); \n}\n\n.button_mod-disabled_1rf31 {\n    cursor: auto;\n    opacity: .5;\n}\n\n.button_mod-disabled_1rf31:active {\n    background: none;\n}\n", ""]);

// exports
exports.locals = {
	"button": "button_button_u6SE2",
	"highlighted": "button_highlighted_2cM8r",
	"mod-disabled": "button_mod-disabled_1rf31",
	"modDisabled": "button_mod-disabled_1rf31"
};